import { ReactNode } from "react";
import { IconeTile } from "./cores";

type SectionTitleType = {
  hasButton?: boolean;
  description?: string;
  icon?: ReactNode;
  cor?: string;
  children: React.ReactNode;
};

// Separa seções dentro do card do formulário: ícone + título à esquerda, ação (opcional) à direita
export const SectionTitle = ({ hasButton = false, description, icon, cor = "bg-muted text-muted-foreground", children }: SectionTitleType) => (
  <div className="mb-4 mt-4 w-full border-t pt-6">
    <h2 className={`flex items-center gap-2.5 text-base font-semibold ${hasButton ? '[&>button]:ml-auto' : ''}`}>
      {icon && <IconeTile cor={cor} size="sm">{icon}</IconeTile>}
      {children}
    </h2>
    {description && <p className="mt-1 text-sm text-muted-foreground">{description}</p>}
  </div>
);
